<template>
    <div class="w100">
        <article class="wContent center" style="padding: 10px 0 1px 0">
            <div class="p20 bgWhite">
                <h3 class="cash-title">期货主力合约收盘价</h3>
                <div class="cash-head-list">
                    <div class="p15" v-for="(item, index) in contractData" :key="index"> <!-- :class="{active: contractTag == item.dataNId}" @click="changeContract(item)"-->
                        <p class="cash-head-child1">
                            <span class="inlineBlock">{{item.nodeName}}</span>
                            <span class="inlineBlock vBot">{{item.rq}}</span>
                        </p>
                        <p class="cash-head-child2">
                            <i class="inlineBlock vMid iconfont" :class="{'icon-uparrow fontRed': item.chg > 0, 'icon-downarrow fontGreen': item.chg < 0}" style="font-size: 24px;"></i>
                            <span class="fontNormal inlineBlock vMid">{{ item.data }}</span>
                            <small class="inlineBlock vMid" :class="{'fontGreen': item.chg < 0, 'fontRed': item.chg > 0, 'fontNormal': item.chg == 0}">{{ item.chg }}</small>
                            <small class="inlineBlock vMid" :class="{'fontGreen': item.chg < 0, 'fontRed': item.chg > 0, 'fontNormal': item.chg == 0}">{{ item.range }}%</small>
                        </p>
                    </div>
                </div>
            </div>

            <div v-if="adIDsIndex[0] && adIDsIndex[0]['list']">
                <a v-for="(item, index) in adIDsIndex[0]['list']" :key="index" :href="item.adLink" target="_blank" class="w100 block mw-modular-box">
                    <img :src="item.adPicturePath" alt="" class="w100">
                </a>
            </div>

            <div class="mw-modular-box p20 bgWhite">
                <h3 class="cash-title">期现基差</h3>
                <el-row :gutter="20">
                    <el-col :span="6">
                        <a href="javascript:;" class="block cash-menus w100 textCenter font16" :class="{active: lineTagName == 'futubasirbnonoctma'}" @click="changeLineTag('futubasirbnonoctma', null, '螺纹钢基差')">螺纹钢基差</a>
                        <a href="javascript:;" class="block cash-menus w100 textCenter font16" :class="{active: lineTagName == 'futubasihrnonoctma'}" @click="changeLineTag('futubasihrnonoctma', null, '热卷基差')">热卷基差</a>
                        <a href="javascript:;" class="block cash-menus w100 textCenter font16" :class="{active: lineTagName == 'futubasiiononoctma'}" @click="changeLineTag('futubasiiononoctma', null, '铁矿石基差')">铁矿石基差</a>
                        <a href="javascript:;" class="block cash-menus w100 textCenter font16" :class="{active: lineTagName == 'futubasicononoctma'}" @click="changeLineTag('futubasicononoctma', null , '焦炭基差')">焦炭基差</a>
                        <a href="javascript:;" class="block cash-menus w100 textCenter font16" style="margin: 0" :class="{active: lineTagName == 'futubasiccnonoctma'}" @click="changeLineTag('futubasiccnonoctma', null, '焦煤基差')">焦煤基差</a>
                    </el-col>
                    <el-col :span="18">
                        <div style="height: 305px;" ref="lineChart"></div>
                    </el-col>
                </el-row>
            </div>

            <div class="mw-modular-box p20 bgWhite">
                <h3 class="cash-title">跨品种基差与比值</h3>
                <el-row :gutter="20">
                    <el-col :span="6">
                        <a href="javascript:;" class="block cash-menus w100 textCenter font16" :class="{active: lineTagName2 == 'futusprebibtrbctma'}" @click="changeLineTag('futusprebibtrbctma',2, '螺纹主力与钢坯价差')">螺纹主力与钢坯价差</a>
                        <a href="javascript:;" class="block cash-menus w100 textCenter font16" :class="{active: lineTagName2 == 'futusprerbbtioctma'}" @click="changeLineTag('futusprerbbtioctma',2, '螺纹主力与矿石主力比值')">螺纹主力与矿石主力比值</a>
                        <a href="javascript:;" class="block cash-menus w100 textCenter font16" :class="{active: lineTagName2 == 'futusprerbbthrctma'}" @click="changeLineTag('futusprerbbthrctma',2, '螺纹主力与热卷主力价差')">螺纹主力与热卷主力价差</a>
                        <a href="javascript:;" class="block cash-menus w100 textCenter font16" :class="{active: lineTagName2 == 'futusprerbbtcoctma'}" @click="changeLineTag('futusprerbbtcoctma',2, '螺纹主力与焦炭主力比值')">螺纹主力与焦炭主力比值</a>
                        <a href="javascript:;" class="block cash-menus w100 textCenter font16" style="margin: 0" :class="{active: lineTagName2 == 'futusprerbbtccctma'}" @click="changeLineTag('futusprerbbtccctma',2, '焦炭主力与焦煤主力比值')">焦炭主力与焦煤主力比值</a>
                    </el-col>
                    <el-col :span="18">
                        <div style="height: 305px;" ref="lineChart2"></div>
                    </el-col>
                </el-row>
            </div>

            <div class="mw-modular-box bgWhite">
                <!-- <el-row class="service-tbox">
                    <el-col :span="12">
                        <div class="service-tleft textCenter center">
                            <h2 class="font18">我们的服务内容</h2>
                            <small class="block">钢铁行业大数据分析</small>
                            <small class="block">唐宋大数据产业股份有限公司为您提供最专业 最放心的钢铁行业大数据分析，让您拥有最完美体验。</small>
                            <router-link to="" class="inlineBlock">了解更多</router-link>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <img src="../../assets/images/qixian_1.png" alt="" srcset="" class="w100 service-tright">
                    </el-col>
                </el-row> -->

                <div class="mw-modular-box bgWhite p20" style="position: relative">
                    <img src="../../assets/images/qixian_6.png" alt="" srcset="" class="service-fImg w100">
                    <div class="service-fbox textCenter w100">
                        <div class="fontWhite">
                            <span class="fontBold block p15" style="font-size: 26px">CASES</span>
                            <span class="block font16 fontBold">服务特色</span>
                            <!-- <span class="block font14 p20">您所需要的，我们刚好专业</span> -->
                        </div>
                        <div class="inlineBlock vMid fwts-box fontWhite radius">
                            <h3><img src="../../assets/images/qixian_7.png" alt=""></h3>
                            <p class="center">唐宋大数据国内领先的钢铁大数据体系和算法体系，领先的钢铁市场信息和数据服务体系。</p>
                        </div>
                        <div class="inlineBlock vMid fwts-box fontWhite radius">
                            <h3><img src="../../assets/images/qixian_8.png" alt=""></h3>
                            <p class="center">唐宋大数据多年积累的自主采集的钢铁大数据库。</p>
                        </div>
                        <div class="inlineBlock vMid fwts-box fontWhite radius">
                            <h3><img src="../../assets/images/qixian_9.png" alt=""></h3>
                            <p class="center">唐宋大数据基本面量化交易策略研究，让数据说话，摒弃主观臆断。</p>
                        </div>
                        <div class="inlineBlock vMid fwts-box fontWhite radius">
                            <h3><img src="../../assets/images/qixian_10.png" alt=""></h3>
                            <p class="center">唐宋大数据资深的服务团队定向服务，具有专业化的基本面量化交易策略研发能力，多年的市场研究服务经验。</p>
                        </div>
                        <!-- <router-link to="/" class="inlineBlock vMid p5">
                            <img src="../../assets/images/qixian_7.png" alt="" srcset="" class="w100">
                        </router-link>
                        <router-link to="/" class="inlineBlock vMid p5">
                            <img src="../../assets/images/qixian_7.png" alt="" srcset="" class="w100">
                        </router-link>
                        <router-link to="/" class="inlineBlock vMid p5">
                            <img src="../../assets/images/qixian_7.png" alt="" srcset="" class="w100">
                        </router-link>
                        <router-link to="/" class="inlineBlock vMid p5">
                            <img src="../../assets/images/qixian_7.png" alt="" srcset="" class="w100">
                        </router-link> -->
                    </div>
                </div>

                <el-row :gutter="80" class="service-bbox mw-modular-box textCenter">
                    <el-col :span="8">
                        <!-- <div>
                            <img src="../../assets/images/qixian_2.png" alt="" class="" style="margin-bottom: 30px;">
                        </div> -->
                        <h1 class="" style="margin-bottom: 30px; font-size: 34px; letter-spacing: 5px;">价格风险管理</h1>
                        <small style="line-height: 20px">识别市场价格趋势，管理价格变动对经营的影响<br/>发现价格变动引发的经营机会<br/>规避价格频繁、剧烈变动引发的经营风险</small>
                    </el-col>
                    <el-col :span="8">
                        <!-- <div>
                            <img src="../../assets/images/qixian_3.png" alt="" class="" style="margin-bottom: 30px;">
                        </div> -->
                        <h1 class="" style="margin-bottom: 30px; font-size: 34px; letter-spacing: 5px;">库存价值管理</h1>
                        <small style="line-height: 20px">优化库存，管理市场价格变动引发的库存价值波动<br/> 实现存货的预期收益<br/>防范存货贬值的风险</small>
                    </el-col>
                    <el-col :span="8">
                        <!-- <div>
                            <img src="../../assets/images/qixian_4.png" alt="" class="" style="margin-bottom: 30px;">
                        </div> -->
                        <h1 class="" style="margin-bottom: 30px; font-size: 34px; letter-spacing: 5px;">采购周期管理</h1>
                        <small style="line-height: 20px">优化采购，合理确定采购周期，合理选择采购方式<br/>降低采购成本<br/>防范市场价格变动引发的采购失误</small>
                    </el-col>
                    <!-- <el-col :span="6">
                        <div class="textCenter">
                            <img src="../../assets/images/qixian_5.png" alt="" class="" style="width: 140px; margin-bottom: 30px;">
                        </div>
                        <small>从战略角度出发，对品牌进行思考和重构，提供科学完整的品牌标志策略与设计、视觉审计与诊断，吉祥物设计等，量身定制合适企业的互联网形象，完善用户与企业的接触点。</small>
                    </el-col> -->
                </el-row>
            </div>

            

            <div class="mw-modular-box bgWhite billet-part-5">
                <h3 class="textCenter">
                    <img src="../../assets/images/billet_2.png" alt="">
                </h3>
                <div class="get-concat-box center" style="width: 870px;">
                    <div class="inlineBlock vTop" style="margin-top: -15px;">
                        服务热线：400-6565-958 <br>
                        <!-- 总公司：Bejing Head Office <br>
                        地址：北京市海淀区西三环北路89号中国外文大厦A906 <br>
                        电话：010-88570912/88570922传真：010-88570922 <br> -->
                        总部基地：Headquarters Base <br>
                        地址：河北省唐山市高新区建设北路冀东新闻中心5层 <br>
                        电话：0315-5921001/400-6565-958传真：0315-5921091/5921092 <br>
                    </div>
                    <div style="height: auto; width: 155px; margin-left: 100px; margin-top: 0" class="inlineBlock vTop textCenter">
                        <img src="../../assets/images/header_code.png" alt="" srcset="">
                        <p class="textCenter font14">扫一扫关注公众号</p>
                    </div>
                    <div style="height: auto; margin-top: 0; margin-left: 50px" class="inlineBlock vTop textCenter">
                        <img src="../../assets/images/footer_down.png" alt="" srcset="" style="width: 117px; margin-top: 6px; margin-bottom: 4px;">
                        <p class="textCenter font14">唐宋钢铁APP</p>
                    </div>
                </div>
            </div>
        </article>
        <ConcatsControl></ConcatsControl>
    </div>
</template>

<script>
import ConcatsControl from '../../templates/concatsControl'
import { baseUrl,adIDs } from '../../assets/js/common'
import { LineOption_2 } from '../../assets/js/options'
export default {
    name: 'CurrentCash',
    components: { ConcatsControl },
    data () {
        return {
            contractData: [],
            lineTagName: 'futubasirbnonoctma',
            lineTagName_n: '螺纹钢基差',
            lineTagName2: 'futusprebibtrbctma',
            lineTagName_n2: '螺纹主力与钢坯价差',
            adIDsIndex: []
            // contractTag: ''
        }
    },
    mounted () {
        // 初始化内容
        this.industriaContractData();
        this.industriaDataVo(null);
        this.industriaDataVo(2);
        this.getAdByAdp();

    },
    methods: {
        //页面操作
        // 获取广告信息
        getAdByAdp () {
            const self = this;
            self.adIDsIndex = [{
                name: 'qxtonglan1',
                id: adIDs['qxtonglan1'],
                list: []
            }];
            self.adIDsIndex.forEach((item, index) => {
                self.$get(`${baseUrl.cyw}/industriaAD/getAdByAdp?adpId=${item.id}`, {}).then(res => {
                    if (res.code == 0) {
                        self.adIDsIndex[index]['list'] = res.data;
                    }
                })
            })
        },
        // 获取收盘价
        industriaContractData () {
            const self = this;
            self.$get(`${baseUrl.online}/futureData/industriaContractData`, {}).then(res => {
                if (res.code == 0) {
                    let nameIndex = '';
                    res.data.forEach((item, index) => {
                        nameIndex = item.nodeName.indexOf('主');
                        item.nodeName = item.nodeName.substr(0, nameIndex);
                    })
                    self.contractData = res.data;
                    // self.contractTag = res.data[0].dataNId;
                } else {
                    self.$message.error(res.message);
                }
            }).catch(err => {
                self.$message.error('未获取到收盘价信息')
            })
        },

        // 切换左侧选项
        changeLineTag (val, type, name) {
            if (type) {
                this.lineTagName2 = val;
                this.lineTagName_n2 = name;
            } else {
                this.lineTagName = val;
                this.lineTagName_n = name;
            }
            this.industriaDataVo(type);
        },

        // 获取各个图
        industriaDataVo (type) {
            const self = this;
            self.$get(`${baseUrl.online}/futureData/industriaDataVo?code=${type ? self.lineTagName2 : self.lineTagName}`, {}).then(res => {
                if (res.code == 0) {
                    // res.data = res.data.reverse();
                    let lineChart;
                    let option = new LineOption_2();
                    let seriesObj = {
                        type: 'line',
                        name: '',
                        smooth: 0.5,
                        smoothMonotone: 'none',
                        data: []
                    }
                    res.data.forEach((cItem, cIndex) => {
                        seriesObj.data.push(cItem.data)
                        option.xAxis.data.push(cItem.rq);
                    })
                    option.dataZoom = [
                        {
                            type: 'inside',
                            start: 50,
                            end: 100
                        },
                        {
                            show: true,
                            type: 'slider',
                            y: '90%',
                            start: 50,
                            end: 100
                        }
                    ],
                    option.grid.bottom = 50;
                    option.legend.show = false;
                    option.title.show = true;
                    option.title.left = '45%';
                    option.title.textStyle = {
                        fontSize: 14
                    };
                    if (type) {
                        lineChart = self.$echarts.init(self.$refs.lineChart2);
                        seriesObj.name = self.lineTagName_n2;
                        option.title.text = self.lineTagName_n2;
                        option.series.push(seriesObj);
                    } else {
                        lineChart = self.$echarts.init(self.$refs.lineChart);
                        seriesObj.name = self.lineTagName_n;
                        option.title.text = self.lineTagName_n;
                        option.series.push(seriesObj);
                    }
                    lineChart.setOption(option);
                }
            })
        }
    },
}
</script>

<style scoped>
    @import url('currentCash.css');
</style>